// A valid phone number consists of 10 digits
const validatePhone = value => /^[0-9]{10}$/.test( value );

export default validatePhone;
